import type { SpinProps as AntSpinProps } from "antd/lib/spin";
import AntSpin from "antd/lib/spin";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import styles from "./Spin.module.css";

export type SpinProps = AntSpinProps;

export const Spin = ({ wrapperClassName, ...props }: SpinProps) => {
    const [t] = useTranslation();

    return (
        <AntSpin
            tip={t("@sol.uikit.feedback.Spin.tip")}
            wrapperClassName={clsx(styles.spin, wrapperClassName)}
            {...props}
        />
    );
};
